'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-param-reassign */
var setItemsInSchema = function setItemsInSchema(schema, ds) {
  if (!schema || !schema.properties || !schema.properties[ds.property]) {
    return;
  }

  var ids = ds.values.map(function (v) {
    return v.id;
  });
  var names = ds.values.map(function (v) {
    return v.name;
  });

  if ('items' in schema.properties[ds.property]) {
    delete schema.properties[ds.property].items.enum;
    delete schema.properties[ds.property].items.enumNames;

    schema.properties[ds.property].items.enum = ids;
    schema.properties[ds.property].items.enumNames = names;
  } else {
    delete schema.properties[ds.property].enum;
    delete schema.properties[ds.property].enumNames;

    schema.properties[ds.property].enum = ids;
    schema.properties[ds.property].enumNames = names;
  }

  schema.properties[ds.property].itemsDataSource = ds.values;
};

exports.default = setItemsInSchema;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/utils/setItemsInSchema.js
// module id = 1128
// module chunks = 5